export default "__VITE_ASSET__ee5e2f9b__"